import React         from 'react';
import TextComponent from '../TextComponent';

const WidthText = (props) => {
  const name = 'carrier_width';
  const defaultChange = e => props.onChangeParameter(name, e.target.value);

  const onChange = props.onChange || defaultChange;
  return (
    <TextComponent
      label={props.label}
      name={name}
      value={props.parameters[name] || ''}
      required={props.required}
      onChange={onChange}
      tooltip={props.tooltip}
      groupName={props.groupName} >
      {props.children}
    </TextComponent>
  );
};

WidthText.defaultProps = {
  required: true,
  label   : 'Carrier Width ',
};

export default WidthText;
